require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-neusiedl-andau.json") })
        }
      }, "path---betreuungseinrichtungen-neusiedl-andau");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-neusiedl-andau!./.cache/json/betreuungseinrichtungen-neusiedl-andau.json
// module id = 943
// module chunks = 231608221292675